import { render } from "./product-single-3.vue?vue&type=template&id=51349af4&scoped=true"
import script from "./product-single-3.vue?vue&type=script&lang=js"
export * from "./product-single-3.vue?vue&type=script&lang=js"

import "./product-single-3.vue?vue&type=style&index=0&id=51349af4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51349af4"]])

export default __exports__